import {useCallback, useState} from "react";
import {editHistoryReportExcel, editHistoryReportNew} from "../../../../Service/service.Parcels";

const useUpdateHistoryReportData = () => {
    const [loading, setLoading] = useState(false);
    const [loadingExcel,setLoadingExcel] = useState(false);
    const [error , setError] = useState(null);
    const [data, setData] = useState(null);
    const [dataExport,setDataExport] = useState(null);

    const fetchData = useCallback(
        async (search,cust_code,start_date,end_date,page) => {
            try{
                setLoading(true);
                let result = await editHistoryReportNew(search,cust_code,start_date,end_date,page);
                // alert(JSON.stringify(result))
                // alert(result.data===false);
                setData(result.data===false?{maxPage:1,result:[],pageNo:1,numRowsAll:0,perPage:20}:result.data);
            }
            catch (e) {
                console.error(e);
                setError('An error occured');
            }
            finally {
                setLoading(false);
            }
        },
        [],
    );

    const fetchDataExcel = useCallback(
        async (search,cust_code,start_date,end_date) => {
            try{
                setLoadingExcel(true);
                let result = await editHistoryReportExcel(search,cust_code,start_date,end_date);
                alert(JSON.stringify(result))
                setDataExport(result.data===false?[]:result.data);
            }
            catch (e) {
                console.error(e);
                setError('An error occured');
            }
            finally {
                setLoadingExcel(false);
            }
        },
        [],
    );


    return {
        data,
        dataExport,
        error,
        loading,
        loadingExcel,
        fetchData,
        fetchDataExcel
    }
}



export default useUpdateHistoryReportData;